import { createPinia } from 'pinia';
import { useUserDataStore } from './userDataStore';

const pinia = createPinia();

const userDataStore = useUserDataStore(pinia);
userDataStore.initializeStore();

export default pinia;
